import Marquee from "react-fast-marquee";

const items = [
  "YOUR WOUND OUR CARE",
  "ADVANCED MEDICAL ADHESIVE",
  "CLINICALLY PROVEN",
  "BIOACTIVE FORMULATION",
  "SEAL · PROTECT · HEAL",
];

export const EditorialMarquee = () => (
  <div className="bg-primary py-5 border-y border-accent/40" data-testid="editorial-marquee">
    <Marquee speed={40} gradient={false}>
      {items.concat(items).map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-heading font-bold uppercase text-2xl md:text-3xl tracking-wider text-secondary px-8">
            {t}
          </span>
          <span className="w-2 h-2 rounded-full bg-secondary/60" />
        </span>
      ))}
    </Marquee>
  </div>
);
